export interface HezkyCommonListValue<T = any> {
    label: string;
    value: T;
}

export const TRANSPORT_MODE_OPTIONS: HezkyCommonListValue<string>[] = [
    { value: 'air', label: 'Air' },
    { value: 'road', label: 'Road' },
    { value: 'sea', label: 'Sea' },
    { value: 'rail', label: 'Rail' }
];